export enum EMortgageBuildingType {
  NewBuilding,
  OldBuilding,
  Suburban,
  HousePart,
}
